export default __webpack_public_path__ + "static/media/151-monumental.dc24d509.png";